export function normaliseStr(str: string): string {
  return str.trim().replace(/\s+/g, '').toLowerCase()
}
